<section class="app-dialog configuracion-editor-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <div class="configuracion-editor-dialog__icon" aria-hidden="true">
        <mat-icon>tune</mat-icon>
      </div>

      <div>
        <p class="app-dialog__eyebrow">Configuración general</p>
        <h2>{{ isEditMode ? "Modificar configuración secundaria" : "Nueva configuración secundaria" }}</h2>
        <p>
          Configuración primaria:
          <strong>{{ ConfiguracionSec.conf_fol_pr || "Sin selección" }}</strong>
        </p>
      </div>
    </div>

    <button
      type="button"
      mat-icon-button
      class="app-dialog__close"
      aria-label="Cerrar diálogo"
      [disabled]="isSaving"
      (click)="onNoClick()">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <form [formGroup]="formVersion" autocomplete="off" (ngSubmit)="save()">
    <div mat-dialog-content class="app-dialog__content configuracion-editor-dialog__content">
      <div class="configuracion-editor-dialog__field-wrap configuracion-editor-dialog__field-wrap--name">
        <label class="configuracion-editor-dialog__label" for="configuracionNombre">
          Nombre de la configuración <span aria-hidden="true">*</span>
        </label>
        <mat-form-field appearance="outline" class="configuracion-editor-dialog__field">
          <input
            id="configuracionNombre"
            matInput
            formControlName="nameVersionCtrl"
            maxlength="25"
            required />
          <mat-error *ngIf="formVersion.controls.nameVersionCtrl.hasError('required')">
            Capture el nombre de la configuración.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="configuracion-editor-dialog__section-heading">
        <div>
          <h3>Parámetros</h3>
          <p>Capture al menos el primer par. Los pares adicionales son opcionales.</p>
        </div>
        <span>Descripción / valor</span>
      </div>

      <div class="configuracion-editor-dialog__pairs">
        <section
          *ngFor="let pair of parameterPairs; let index = index"
          class="configuracion-editor-dialog__pair">
          <div class="configuracion-editor-dialog__pair-number" aria-hidden="true">{{ index + 1 }}</div>

          <div class="configuracion-editor-dialog__field-wrap">
            <label
              class="configuracion-editor-dialog__label"
              [for]="'configuracionDescripcion' + (index + 1)">
              Descripción {{ index + 1 }}
              <span *ngIf="index === 0" aria-hidden="true">*</span>
            </label>
            <mat-form-field appearance="outline" class="configuracion-editor-dialog__field">
              <input
                matInput
                [id]="'configuracionDescripcion' + (index + 1)"
                [formControlName]="pair.descriptionControl"
                maxlength="150"
                [required]="index === 0"
                (input)="updatePairValidation(pair)" />
              <mat-error *ngIf="formVersion.controls[pair.descriptionControl].hasError('required')">
                Capture la descripción {{ index + 1 }}.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="configuracion-editor-dialog__field-wrap">
            <label
              class="configuracion-editor-dialog__label"
              [for]="'configuracionValor' + (index + 1)">
              Valor {{ index + 1 }}
              <span *ngIf="index === 0" aria-hidden="true">*</span>
            </label>
            <mat-form-field appearance="outline" class="configuracion-editor-dialog__field">
              <input
                matInput
                [id]="'configuracionValor' + (index + 1)"
                [formControlName]="pair.valueControl"
                maxlength="150"
                [required]="index === 0"
                (input)="updatePairValidation(pair)" />
              <mat-error *ngIf="formVersion.controls[pair.valueControl].hasError('required')">
                Capture el valor {{ index + 1 }}.
              </mat-error>
            </mat-form-field>
          </div>
        </section>
      </div>
    </div>

    <footer mat-dialog-actions class="app-dialog__footer configuracion-editor-dialog__footer">
      <button
        type="button"
        class="app-form-btn app-form-btn--compact configuracion-editor-dialog__button--clear"
        [disabled]="isSaving"
        (click)="clear()">
        Limpiar
      </button>
      <button
        type="button"
        class="app-form-btn app-form-btn--compact configuracion-editor-dialog__button--cancel"
        [disabled]="isSaving"
        (click)="onNoClick()">
        Cancelar
      </button>
      <button
        type="submit"
        class="app-form-btn app-form-btn--compact configuracion-editor-dialog__button--save"
        [disabled]="formVersion.invalid || isSaving">
        <mat-icon aria-hidden="true">{{ isSaving ? "hourglass_top" : "save" }}</mat-icon>
        {{ isSaving ? "Guardando..." : "Guardar" }}
      </button>
    </footer>
  </form>
</section>
